import {Brain, ChevronDown, Clapperboard, FolderOpen, Images, Layers, Palette, Users, Video, Wallet} from '@nlabs/gothamjs/icons';

import {FeatureDiagram} from '../FeatureDiagram/FeatureDiagram.js';

import type {ReactElement} from 'react';
import type {FeatureDetail} from '../../content/features.js';

const icons = {
  characters: Users,
  credits: Wallet,
  elements: Layers,
  gemini: Brain,
  memory: Brain,
  projects: FolderOpen,
  'quick-video': Video,
  seedance: Clapperboard,
  storyboards: Images,
  style: Palette,
  takes: Images
};
const badgeStyles = {

  Free: 'border-emerald-300/20 bg-emerald-300/8 text-emerald-200',
  'Paid plan': 'border-violet-300/20 bg-violet-300/8 text-violet-200'
};

export const FeatureRow = ({feature}: {readonly feature: FeatureDetail}): ReactElement => {
  const Icon = icons[feature.id as keyof typeof icons] || Layers;
  return <details className="group border-t border-white/10 first:border-t-0 open:bg-violet-300/4">
    <summary className="grid cursor-pointer list-none grid-cols-[32px_minmax(0,1fr)_16px] items-center gap-x-3 gap-y-1 px-4 py-2.5 transition-colors hover:bg-white/3 focus-visible:outline-2 focus-visible:outline-offset-[-3px] focus-visible:outline-violet-300 md:grid-cols-[32px_220px_minmax(0,1fr)_100px_16px] md:gap-x-4 md:px-6 [&::-webkit-details-marker]:hidden">
      <span aria-hidden="true" className="flex size-8 items-center justify-center rounded-lg bg-violet-300/8 text-violet-300"><Icon size={16} strokeWidth={1.6} /></span>
      <span className="font-heading text-base font-medium leading-5 text-white/90">{feature.title}</span>
      <span className="col-start-2 row-start-2 text-xs leading-5 text-zinc-200 md:col-start-auto md:row-start-auto">{feature.summary}</span>
      <span className={`col-start-2 row-start-3 w-fit rounded-md border px-2 py-0.5 text-[11px] leading-5 md:col-start-auto md:row-start-auto ${badgeStyles[feature.availability]}`}>{feature.availability}</span>
      <ChevronDown aria-hidden="true" className="col-start-3 row-start-1 text-zinc-200 transition-transform group-open:rotate-180 motion-reduce:transition-none md:col-start-auto md:row-start-auto" size={16} />
    </summary>
    <div className="border-t border-white/5 px-5 py-5 md:px-18">
      <p className="max-w-3xl text-sm leading-6 text-zinc-200">{feature.description}</p>
      <FeatureDiagram featureId={feature.id} />
      <ul className="mt-3 max-w-3xl list-disc space-y-2 pl-4 text-xs leading-6 text-zinc-200 marker:text-violet-300">{feature.details.map((detail) => <li key={detail}>{detail}</li>)}</ul>
    </div>
  </details>;
};
